export default __webpack_public_path__ + "static/media/downloadourappimage1.0dd8b7c3.png";